import { forwardRef, type ForwardedRef, type ReactNode } from "react";
import { tw } from "src/design-system/tw";
import { useScreenMinWidth } from "src/utils/hooks/useScreenMinWidth";
import { useHotelsContext } from "../../domain/HotelsScreen/HotelsContext";

// This is the same max height as the right rail ad column.
const MAP_MAX_HEIGHT = 1216;

type Props = {
  leftPane: ReactNode;
  background?: ReactNode;
  rightRail?: ReactNode;
};

function LayoutInner(props: Props, ref: ForwardedRef<HTMLDivElement>) {
  const { showMap: showMapMobile } = useHotelsContext();
  const { isMobile } = useScreenMinWidth();

  if (isMobile) {
    return (
      <main ref={ref} id="layout-container">
        {props.leftPane}
        {props.background && (
          <div
            className={tw(
              "fixed inset-0 overflow-hidden",
              !showMapMobile && "left-full",
            )}
          >
            {props.background}
          </div>
        )}
      </main>
    );
  }

  return (
    <main
      ref={ref}
      id="layout-container"
      className="flex justify-center bg-surface-secondary-active px-4 pt-6 pb-12"
    >
      <div className="grid w-full max-w-[var(--breakpoint-3xl)] grid-cols-[minmax(0,2fr)_minmax(0,2fr)_auto] xl:grid-cols-[minmax(0,2fr)_minmax(0,3fr)_auto] 3xl:grid-cols-[minmax(0,600px)_minmax(0,3fr)_auto]">
        {props.leftPane}
        {props.background && (
          <div
            className="sticky top-[var(--spacing-header-height-padded)] ml-4 overflow-hidden rounded-xl"
            style={{
              height: `calc(100vh - var(--spacing-header-height-padded) - var(--spacing-2xl))`,
              maxHeight: `${MAP_MAX_HEIGHT}px`,
            }}
          >
            {props.background}
          </div>
        )}
        {props.rightRail}
      </div>
    </main>
  );
}

export const Layout = forwardRef(LayoutInner);
